import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { File } from '../../models/files/files.model';

@Injectable()
export class FilesService {

  private _filesChosenSource = new Subject<{ files: File[], guid: string }>();
  private _browserToggledSource = new Subject<any>();

  filesChosen$ = this._filesChosenSource.asObservable();
  browserToggled$ = this._browserToggledSource.asObservable();

  constructor() {
   }

  setChosenFiles(fileResponse: { files: File[], guid: string }) {
    this._filesChosenSource.next(fileResponse);
  }

  toggleBrowser(browseConfig: any) {
    this._browserToggledSource.next(browseConfig);
  }
}
